export default __webpack_public_path__ + "static/section_9_details_1-6158f59a62be18e6b66fd90e6e7a1678.png";